import React from "react";
import { useState, useEffect, useRef, useContext, useCallback } from "react";
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";
import * as Config from "../../config/config";
import { useAuth } from "../../hooks/customers/AuthProvider";
import Menusearch from "../menu/Menusearch";
import Favouritestitle from "../favourite/Favouritestitle";
import Favouriteitems from "../favourite/Favouriteitems";
import { LoaderContext } from "../utils/Contexts";
import { useTranslation } from "react-i18next";

function Favourites(props) {
  const { t } = useTranslation();
  const auth = useAuth();
  const cusId = auth.customer._id;

  const { isLoader, setLoader } = useContext(LoaderContext);
  const [favoriteProducts, setFavoriteProducts] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentCount, setCurrentCount] = useState(0);
  //const [searchTerm, setSearchTerm] = useState(null);
  const listInnerRef = useRef();
  //const [page, setPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);
  const [wasLastList, setWasLastList] = useState(false);
  const [title, setTitle] = useState(t("favourites"));
  const [lastPage, setLastPage] = useState(null);

  const payload = {
    limit: Config.FAVOURITES_LIMIT,
  };
  const queryParams = new URLSearchParams(payload).toString();

  const fetchFavorites = async (append) => {
    if (lastPage == props.page) return;
    setLastPage(props.page);
    setLoader(true);
    let url = `${ENDPOINTS.GET_FAVORITE_PRODUCTS}/${cusId}?${queryParams}&page=${props.page}`;
    const response = await API.getWithToken(url);
    setLoader(false);
    if (response.statusText === "OK" && response?.data?.data?.totalCount > 0) {
      setTotalCount(response.data.data.totalCount);
      if (append) {
        setFavoriteProducts([
          ...favoriteProducts,
          ...response.data.data.favourites,
        ]);
        
      } else {
        setFavoriteProducts(response.data.data.favourites);
      }
      setCurrentCount(response.data.data.pages);
      // if (response.data.data.favourites.length < Config.FAVOURITES_LIMIT) {
      //   setWasLastList(true);
      //   setLastPage(props.page);
      // }
      if (response.data.data.favourites.length) {
        props.setPage(prev => prev + 1);
        props.setIsFetching(false);
      }
    
    } else {
      setFavoriteProducts([]);
    }
  };

  // useEffect(() => {
  //   if (!wasLastList) {
  //     fetchFavorites(true);
  //   }
  // }, [wasLastList,props.page]);

  useEffect(() => {
   
    if (!props.isFetching) return;
    fetchFavorites(true);
  }, [props.isFetching]);

   useEffect(() => {
     if (props.page === 1) {
       fetchFavorites(false); // Fresh load
       //setFavoriteProducts([]); // Clear old items
       setLastPage(null); // Reset lastPage tracking
       
     }
   }, [props.page]);
   

const removeFavoriteLocally = (productId) => {
  setFavoriteProducts((prev) =>
    prev.filter((item) =>
      item.productId ? item.productId._id !== productId : item._id !== productId
    )
  );
};


  return (
    <>
      <Favouritestitle
        itemCount={totalCount}
        title={title}
        currentCount={currentCount}
      />
      <div className="heightscr- customscroll-">
        {favoriteProducts.length > 0 && (
          <Favouriteitems
            favouriteItems={favoriteProducts}
            fetchFavoriteProducts={fetchFavorites}
            setPage = {props.setPage}
            cusId={cusId}
            removeFavoriteLocally={removeFavoriteLocally}
          />
        )}
        {!isLoader && favoriteProducts.length <= 0 && (
          <div className="empty-search-result-wrapper">
            <div className="empty-search-result">{t('no_result_found_txt')}</div>
          </div>
        )}
      </div>
    </>
  );
}

export default Favourites;
